import { useState, useEffect } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { MessageSquare, LayoutDashboard, Inbox, Users, Bot, Layers, BookOpen, LogOut, Menu, X, ChevronLeft, Phone, Globe, Activity } from 'lucide-react';
import { getAuth, clearAuth } from '@/lib/auth';

const NAV = [
  { label: 'Sala de Comando', icon: Activity, path: '/admin/atendimento/command' },
  { label: 'Dashboard', icon: LayoutDashboard, path: '/admin/atendimento' },
  { label: 'Caixa de Entrada', icon: Inbox, path: '/admin/atendimento/inbox' },
  { label: 'Agentes IA', icon: Bot, path: '/admin/atendimento/agents' },
  { label: 'Filas', icon: Layers, path: '/admin/atendimento/queues' },
  { label: 'Base Conhecimento', icon: BookOpen, path: '/admin/atendimento/knowledge' },
  { label: 'WhatsApp', icon: Phone, path: '/admin/atendimento/whatsapp' },
  { label: 'Webchat', icon: Globe, path: '/admin/atendimento/webchat' },
];

export default function AtendimentoLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const auth = getAuth();
  const isActive = (p) => p === '/admin/atendimento' ? location.pathname === p : location.pathname.startsWith(p);

  return (
    <div className="flex min-h-screen">
      <aside className="w-[220px] border-r border-white/10 flex flex-col flex-shrink-0" style={{background:'rgba(15,20,24,0.95)'}}>
        <div className="p-4 border-b border-white/10">
          <button onClick={() => navigate('/admin')} className="flex items-center gap-2 text-white/50 hover:text-white/80 text-xs mb-2"><ChevronLeft size={14}/> Admin</button>
          <div className="flex items-center gap-2">
            <MessageSquare size={18} style={{color:'var(--rn-green)'}}/>
            <h2 className="font-display text-sm font-semibold">Atendimento</h2>
          </div>
        </div>
        <nav className="flex-1 py-3 px-2 space-y-0.5">
          {NAV.map(item => (
            <button key={item.path} onClick={() => navigate(item.path)}
              className={`w-full flex items-center gap-2.5 rounded-xl px-3 py-2 text-xs transition-colors ${
                isActive(item.path) ? 'bg-white/[0.06] text-white' : 'text-white/50 hover:text-white/80 hover:bg-white/[0.03]'
              }`}>
              <item.icon size={15} className={isActive(item.path) ? 'text-[var(--rn-green)]' : ''}/>
              {item.label}
            </button>
          ))}
        </nav>
        <div className="p-3 border-t border-white/10">
          <p className="text-[9px] text-white/20 text-center">Atendimento v1.0</p>
        </div>
      </aside>
      <main className="flex-1 min-h-screen overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}
